export default {
    //GMB
    gmbBrands: [],
    gmbAgents: [],
    gmbLocations: [],
    ActiveAgent: {},
    GmbFlows: [],
    GmbRepresentatives: [],
}